//TODO: Fix linting issues in this file and remove the eslint-disable comments
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

type MeasurePoint = { name: string, time: number, delta: number };
/**
 * Entwickler-Logger mit Timing/Gruppierung für Bot-Runs (`RAGAI.LOG`).
 * @remarks
 * Rein ein Diagnose-Werkzeug für die Browser-Konsole (Run-Timings, Delta zwischen Schritten, Log-Gruppen) -
 * hat keine Auswirkung auf Bot-Verhalten oder gespeicherte Daten. Standardmäßig deaktiviert (`enabled = false`);
 * muss explizit über {@link enable} aktiviert werden.
 */
@Injectable({ providedIn: 'root' })
export class RagLoggerService {
  /**
   *
   * example: callerInfo(this)
   * @param {unknown} instance  ( die instanz aus der diese methode auggerufen wird)
   * @memberof RagLoggerService
   */

  private currentMainGroup = "Without Run";
  private groupeMode: "run" | "withoutRun" | "none" = "none";
  private deltaStarted = false;
  private deltaCounter = 0;
  private collapsed = true; // this is used to unfold the logger in production
  private currentRunStartTime = 0;
  private prevTiming = 0;
  private colorBlue = "\x1b[94m"; // Gray
  private colorReset = "\x1b[0m"; // reset
  private firstDeltaTime = "";
  private prevHookName = "";
  private _filter = "";
  private oldDelta = 0;
  private enabled = false;
  private allTotalTimes: number[] = [];
  private measurePoints: MeasurePoint[] = [];
  private getAverageTime(): number {
    if (this.allTotalTimes.length === 0) return 0;
    const sum = this.allTotalTimes.reduce((acc, val) => acc + val, 0);
    return Math.round(sum / this.allTotalTimes.length);
  }
  private addMeasurePoint(name: string) {
    const time = +(performance.now() - this.currentRunStartTime).toFixed(0);
    let delta = 0;
    const p = this.measurePoints[this.measurePoints.length - 1];
    if (p) {
      delta = time - (this.measurePoints.length > 0 ? p.time : 0);
    }
    this.measurePoints.push({ name, time, delta });
  }

  constructor() {





    if (this._getEnabled()) {
      console.log("RAGAI.LOG is enabled by localStorage");
      console.log("FILTER SET-> TO " + localStorage.getItem("ragLoggerFilter"));
      console.log("ℹ️ disable it by setting RAGAI.LOG.disable()");
    } else {
      console.log("ℹ️ RAGAI.LOG is disabled by localStorage");
      console.log("ℹ️ Enable it by setting RAGAI.LOG.enable()");
    }
    //console.log("RagLoggerService initialized");
  }

  /** Setzt einen Textfilter für die Log-Ausgabe (nur Hooks, deren Name den Filter enthält); leerer String löscht den Filter. */
  public filter(filter: string = "") {

    this._filter = filter;
    if (filter === "") {
      console.log("RAGAI.LOG filter cleared");
      localStorage.removeItem("ragLoggerFilter");
      return;
    }
    localStorage.setItem("ragLoggerFilter", filter);
    console.log("RAGAI.LOG filter set to:", filter);
  }
  /** Aktiviert die Logger-Ausgabe in der Browser-Konsole (persistiert in localStorage). */
  public enable(collapsed = true) {
    localStorage.setItem("ragLoggerEnabled", "true");
    localStorage.setItem("ragLoggerCollapsed", collapsed ? "true" : "false");
    this.collapsed = collapsed;
    this.enabled = true;
    console.log("RAGAI.LOG enabled");
  }

  /** Deaktiviert die Logger-Ausgabe. */
  public disable() {
    this.collapsed = true;
    localStorage.setItem("ragLoggerEnabled", "false");
    this.enabled = false;
    console.log("RAGAI.LOG disabled");
  }

  private _createGroupInternal(strA: string, strB: string = "", strC: string = "") {
    this.collapsed = localStorage.getItem("ragLoggerCollapsed") === "true";
    if (this.collapsed) {
      console.groupCollapsed(strA, strB, strC);
    } else {
      console.group(strA, strB, strC);
    }
  }

  private _getEnabled(): boolean {
    let enabled = false;
    if (localStorage.getItem("ragLoggerEnabled") !== null) {
      enabled = localStorage.getItem("ragLoggerEnabled") === "true";
    }
    return enabled;
  }

  /** Markiert den Start eines Bot-Runs und öffnet eine neue Log-Gruppe mit Zeitmessung. */
  public measureRunStart(prompt: string) {
    if (!this._getEnabled()) {
      return;
    }
    if (this.groupeMode === "withoutRun") {
      console.groupEnd();
    }
    this.groupeMode = "run";
    this.currentRunStartTime = performance.now();
    this.currentMainGroup = prompt;
    this._createGroupInternal("🏃🏻‍♀️", "⏰", prompt);
  }

  /** Protokolliert einen einzelnen internen Hook-Aufruf (io_in_*\/io_out_*) mit Timing-Delta; beendet den Run bei`"runComplete"`. */
  public measureHook(hookName: string, params: unknown) {
    const filter = localStorage.getItem("ragLoggerFilter");
    if (filter && !hookName.includes(filter)) {
      return;
    }
    if (!this._getEnabled()) {
      return;
    }
    if (hookName != "io_in_runUpdate" &&
      this.prevHookName == "io_in_runUpdate") {
      // CLOSE DETLAS
      console.groupEnd();
      const timiing = performance.now() - this.currentRunStartTime;
      console.log("T:" + timiing.toFixed(0) + " ms DELTAS END " + this.deltaCounter + " steps");
      this.deltaCounter = 0;
    }
    if (this.groupeMode == "none") {
      this.groupeMode = "withoutRun";
      this._createGroupInternal("Without Run");
    }
    let direction: "in" | "out" = "in";
    if (
      hookName.includes("io_out") ||
      hookName == "HttpSend"


    ) {
      direction = "out";
    }
    console.groupCollapsed(this._getGroupName(direction == "in" ? "<-" : "->", hookName).padEnd(40), this._subInfos(hookName, params));
    /*  if (this.groupeMode == "run") {
       //  this.logTimingGraph(performance.now() - this.currentRunStartTime);
     } */
    console.log(params);
    console.groupEnd();
    if (hookName == "runComplete") {
      this.measureRunStop();
    }
    this.prevHookName = hookName;
  }

  /** Protokolliert einen benannten Zwischenschritt, optional mit Richtung (ein/aus) und gemessener Ausführungsdauer. */
  public measureRunStep(stepName: string, direction: "in" | "out" | "" = "", executionDuration: number = 0) {
    let icon = "?";
    if (direction == "out") { icon = "->"; }
    if (direction == "in") { icon = "<-"; }
    console.log(this._getGroupName(icon, stepName));
    if (executionDuration > 0) {
      this.logTimingGraph(executionDuration);
    }
  }

  private _getGroupName(icon: string = "", stepName: string): string {
    let timer = "";
    let deltatime = 0;
    let startColor = "";
    let endColor = "";
    if (this.groupeMode == "run") {
      const measureNum = (performance.now() - this.currentRunStartTime);
      deltatime = measureNum - this.prevTiming;
      this.prevTiming = measureNum;
      const numStr = measureNum.toFixed(0).padStart(4, "0");
      timer = " T:" + numStr;
      if (!this.deltaStarted && stepName == "io_in_runUpdate" && this.firstDeltaTime == "") {
        this.addMeasurePoint("firstDeltaTime");
        this.firstDeltaTime = numStr;
        startColor = "\x1b[36m"; // Cyan
        endColor = "\x1b[0m"; // Reset
        this._createGroupInternal(startColor + "+" + this.firstDeltaTime + " ms" + endColor + " DELTAS STARTED");
        this.deltaCounter = 1;
      }
    }
    let deltaString = "";
    if (deltatime > 0) {
      deltaString = this.colorBlue + " D:" + this.colorReset + deltatime.toFixed(0).padStart(4, "0") + "ms";
    }
    let stateicon = "◯";
    if (deltatime > 499) {
      stateicon = "◉";
    }
    if (deltatime > 999) {
      stateicon = "●";
    }

    let gegenstelleIcon = "☁️";
    if (stepName.startsWith("io_")) {
      gegenstelleIcon = "🌐";
    }
    if (stepName.startsWith("RAGAI")) {
      gegenstelleIcon = "🤖";
    }

    return startColor + timer + endColor + " " + stateicon + deltaString + " 👨‍💻 " + icon + " " + gegenstelleIcon + " " + stepName;
  }


  // Hilfsfunktion: Formatiert die Zeit und erstellt einen Balken
  /** Gibt eine gemessene Ausführungsdauer in Millisekunden formatiert in der Konsole aus. */
  public logTimingGraph(duration: number) {
    const colorStart = "\x1b[36m"; // Cyan
    const reset = "\x1b[0m";
    console.log(`  ${colorStart} [${duration.toFixed(0)}] | ms${reset}`);
  }

  /** Beendet den aktuellen Run, schließt die Log-Gruppe und gibt eine Zusammenfassungstabelle der Messpunkte aus. */
  public measureRunStop() {
    const end = performance.now();
    console.groupEnd();
    //console.log("🛑⏱️ - STOP", this.currentMainGroup);
    this.addMeasurePoint("runComplete");
    const totaltime = +(end - this.currentRunStartTime).toFixed(0);
    this.allTotalTimes.push(totaltime);
    console.groupCollapsed("🏁", `first Delta: ${this.firstDeltaTime}ms | Total: ` + totaltime + ` ms  | Average: ` + this.getAverageTime() + `ms`);
    console.table(this.measurePoints);
    //console.log("AVARAGE TOTAL:", this.getAverageTime(), "ms");
    this.measurePoints = [];
    console.groupEnd();
    this.groupeMode = "none";
    this.firstDeltaTime = "";
  }

  private _subInfos(hookName: string, params: any) {
    switch (hookName) {
      case "RAGAI.EVENTS.LISTENTO":
        return params.hook;
      case "io_out_storeKeyValUpdate":
        return params[0].key + "->" + params[0].value;
      case "io_in_stateUpdate":
        if (params[0].sessionState == "thinking") {
          this.addMeasurePoint("thinking");
        }
        return params[0].sessionState;
      case "io_in_debugMsg":
        if (params[0].stat.title.includes("Bot Call Started")) {
          this.addMeasurePoint("Bot Call Started");
        }
        if (params[0].stat.action === "ThreadbotService") {
          return "🏢 Serverside debug";

        }
        return params[0].stat.title.split("<strong>").join("").split("</strong>").join("") + " (" + params[0].stat.executionDuration + "ms)";
      case "io_in_addUserMessage":
        return params[0].message.content;
      case "io_in_runUpdate":
        {
          this.deltaCounter++;
          const content = params[0].content ?? "";
          const deltadiff = content.length - this.oldDelta;
          this.oldDelta = content.length;
          return content.length > 20 ? content.substring(0, 10) + "..." + " +" + deltadiff + " chars /" + " sum " + content.length : content;
        }
      case "io_in_runComplete":
        this.oldDelta = 0;
        return params[0].content;
      case "io_out_getInitialKeyVals":
        return JSON.stringify(params);
      case "io_out_registerDebug":
        return params[0].register;
      default:
        return "-";
    }
  }
}
